import { cn, Flex } from '@bridebook/aura';

export type FieldLabelWrapperProps = React.ComponentPropsWithoutRef<'div'>;

export const FieldTopWrapper = ({ className, children, ...props }: FieldLabelWrapperProps) => (
  <Flex className={cn('flex-col gap-1', className)} {...props}>
    {children}
  </Flex>
);
